import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    country: "us",
    categories: [],
    showDonate: false,
    showNewModal: false,
    api_url: "",
  },
  mutations: {},
  actions: {},
  modules: {},
});
